var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.598,
    height: 19.598,
    viewBox: "0 0 19.598 19.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9609",
    "data-name": "Group 9609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9608",
    "data-name": "Group 9608"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2174",
    "data-name": "Ellipse 2174",
    cx: 0.957,
    cy: 0.957,
    r: 0.957,
    transform: "translate(8.842 13.531)",
    fill: "#2b2a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20548",
    "data-name": "Path 20548",
    d: "M9.8,0a9.8,9.8,0,1,0,9.8,9.8A9.794,9.794,0,0,0,9.8,0Zm0,18.067A8.268,8.268,0,1,1,18.067,9.8,8.263,8.263,0,0,1,9.8,18.067Z",
    fill: "#2b2a2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20549",
    "data-name": "Path 20549",
    d: "M179.062,128.5A3.066,3.066,0,0,0,176,131.562a.766.766,0,1,0,1.531,0,1.531,1.531,0,1,1,1.531,1.531.766.766,0,0,0-.766.766v1.914a.766.766,0,0,0,1.531,0v-1.245a3.062,3.062,0,0,0-.766-6.027Z",
    transform: "translate(-169.263 -123.581)",
    fill: "#2b2a2c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlack);
export default __webpack_public_path__ + "static/media/infoBlack.0a21bfc19ecd7d9411cc87bb52bd1d30.svg";
export { ForwardRef as ReactComponent };